import { PassDeviceType } from "../enums/device-type";
import { ColumnName } from "../models/column-name";

export class ImToolData {
    static readonly legacyAtpWkWarningDialog = {
        alertIcon: "/assets/img/icons/ico.16.warning.svg",
        title: "Legacy ATP Data Source",
        bodyMessage: "WK source is not an approved source for use on Legacy ATP devices and may cause serious unintended consequences.",
        bodyMessage2: "",
        cancelBtnText: "Cancel",
        confirmBtnText: "Continue",
        confirmButtonColor: "btn-light-blue",
        cancelButtonColor: "btn-light-red",
    };
    static devices = [
      { id: 1, deviceName: 'Max 2', isActive: true },
      { id: 6, deviceName: 'ATP(CAPS)', isActive: true },
      { id: 2, deviceName: 'Pass', isActive: true },
      { id: 3, deviceName: 'ATP', isActive: true },
      { id: 4, deviceName: 'SynMed', isActive: true },
      { id: 5, deviceName: 'Mini', isActive: true },
      { id: 7, deviceName: 'Legacy Connect', isActive: true }
    ];
    static countries = [
      { id: 1, countryName: 'USA', isActive: true },
      { id: 2, countryName: 'Canada', isActive: true }
    ];
    static dayOfUsage = [
        { key: '7', value: '7' },
        { key: '14', value: '14' },
        { key: '21', value: '21' },
        { key: '30', value: '30' },
        { key: '45', value: '45' },
        { key: '60', value: '60' },
        { key: '90', value: '90' },
        { key: '120', value: '120' },
        { key: '180', value: '180' },
        { key: '240', value: '240' },
        { key: '300', value: '300' },
        { key: '365', value: '365' }
    ]
    static columnList:ColumnName[]  = [
      { name: "No Usage Data Provided" },
      { name: "No Super cell" },
      { name: "Alphabetical(max only)" },
      { name: "No Locking cell" }
    ];
    static daysPerWeek=[
      { key: 1, value: '1' },
      { key: 2, value: '2' },
      { key: 3, value: '3' },
      { key: 4, value: '4' },
      { key: 5, value: '5' },
      { key: 6, value: '6' },
      { key: 7, value: '7' }]
    static datasource = [
      {key:5, value:'WK (USA)', description:'Preferred Data source for all Products in the US'},
      {key:1, value:'FDB (USA)', description:'Secondary Data source option for USA Drug data, only select this option with manager approval'},
      {key:4, value:'DPD (CAN)', description:'Drug Product Database, Canada repository of approved drugs'}
    ]

    // ATP lists FDB first, then WK. Static so template bindings get a stable reference.
    private static readonly atpDatasource = [...ImToolData.datasource]
      .sort((a, b) => Number(b.key === 1) - Number(a.key === 1));

    static getDatasourceList(deviceId: number) {
      return Number(deviceId) === 3 ? ImToolData.atpDatasource : ImToolData.datasource;
    }

    static deviceTypeLimits = {
      [PassDeviceType.Type18]: { min: 0, max: 4 },
      [PassDeviceType.Type19]: { min: 0, max: 4 },
      [PassDeviceType.Type20]: { min: 1, max: 6 },
      [PassDeviceType.Type21]: { min: 1, max: 8 },
    };
  }

export class ImToolFirstScreenData{
  static ndcLabels = [
    { id: 1, title: 'NDC 11 & NDC11-Hyphenated' },
    { id: 2, title: 'NDC 10 Hyphenated'},
    { id: 3, title: 'NDC 10'},
    { id: 5, title: 'NDC 9'},
    { id: 6, title: 'NDC 12'},
    // { id: 7, title: 'mixed length NDC '}, // Hidden per requirement
  ];
  static ndcLabelsCanada = [
    { id: 4, title: '8 digit DIN' },    
  ];

}
